import React, { useState } from 'react';
import styles from './FirstScreen.module.css';
import Loader from '../components/loader/Loader';
import { FaWhatsapp, FaInstagram, FaFacebookF, FaPhone } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

import ilanit from "../images/אילנית ראשית.webp"

// ייבוא תמונות לקרוסלה
import tilboshot1 from "../images/חינת הזהב תלבושות 1.webp"
import tilboshot2 from "../images/חינת הזהב תלבושות 2.webp"
import tilboshot3 from "../images/חינת הזהב תלבושות 3.webp"
import tilboshot4 from "../images/חינת הזהב תלבושות 4.webp"
import tilboshot5 from "../images/חינת הזהב תלבושות 5.webp"
import tilboshot6 from "../images/חינת הזהב תלבושות 6.webp"
import tilboshot7 from "../images/חינת הזהב תלבושות 7.webp"
import tilboshot8 from "../images/חינת הזהב תלבושות 8.webp"
import tilboshot9 from "../images/חינת הזהב תלבושות 9.webp"
import tilboshot10 from "../images/חינת הזהב תלבושות 10.webp"
import tilboshot11 from "../images/חינת הזהב תלבושות 11.webp"
import tilboshot12 from "../images/חינת הזהב תלבושות 12.webp"
import tilboshot13 from "../images/חינת הזהב תלבושות 13.webp"
import tilboshot14 from "../images/חינת הזהב תלבושות 14.webp"
import tilboshot15 from "../images/חינת הזהב תלבושות 15.webp"
import tilboshot16 from "../images/חינת הזהב תלבושות 16.webp"
import tilboshot17 from "../images/חינת הזהב תלבושות 17.webp"
import tilboshot18 from "../images/חינת הזהב תלבושות 18.webp"

// ייבוא תמונות אירועים לגלריה
import event1 from "../images/אירועים 1.webp"
import event2 from "../images/אירועים 2.webp"
import event3 from "../images/אירועים 3.webp"
import event4 from "../images/אירועים 4.webp"
import event5 from "../images/אירועים 5.webp"
import event6 from "../images/אירועים 6.webp"
import event7 from "../images/אירועים 7.webp"
import event8 from "../images/אירועים 8.webp"
import event9 from "../images/אירועים 9.webp"
import event10 from "../images/אירועים 10.webp"
import event11 from "../images/אירועים 11.webp"
import event12 from "../images/אירועים 12.webp"
import event13 from "../images/אירועים 13.webp"
import event14 from "../images/אירועים 14.webp"
import event15 from "../images/אירועים 15.webp"
import event16 from "../images/אירועים 16.webp"
import event17 from "../images/אירועים 17.webp"
import event18 from "../images/אירועים 18.webp"
import event19 from "../images/אירועים 19.webp"
import event20 from "../images/אירועים 20.webp"
import Shorts from '../components/shorts/Shorts';

const HeroSection = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // State להחלקה (swipe)
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);

  // מינימום מרחק להחלקה (בפיקסלים)
  const minSwipeDistance = 50;

  // פונקציה לפתיחת WhatsApp
  const openWhatsApp = () => {
    const phoneNumber = '972507277178';
    const message = 'היי חינת הזהב, אשמח לקבל עוד פרטים לגבי האירוע שלי';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  // מערך קישורי רשתות חברתיות
  const socialLinks = [
    {
      name: 'WhatsApp',
      icon: <FaWhatsapp />,
      url: `https://wa.me/972507277178?text=${encodeURIComponent('היי חינת הזהב, הגעתי מהדף שלכם! אשמח לשמוע עוד על..')}`,
      label: 'שלחי הודעה בוואטסאפ'
    },
    {
      name: 'Phone',
      icon: <FaPhone />,
      url: 'tel:+972507277178',
      label: 'התקשרי עכשיו'
    },
    {
      name: 'Instagram',
      icon: <FaInstagram />,
      url: 'https://www.instagram.com/hinatazav/',
      label: 'עקבי באינסטגרם'
    },
    {
      name: 'TikTok',
      icon: <SiTiktok />,
      url: 'https://www.tiktok.com/@henatazav',
      label: 'עקבי בטיקטוק'
    },
    {
      name: 'Facebook',
      icon: <FaFacebookF />,
      url: 'https://www.facebook.com/henatazav',
      label: 'עקבי בפייסבוק'
    }
  ];

  // מערך תמונות לקרוסלה
  const carouselImages = [
    tilboshot1, tilboshot2, tilboshot3, tilboshot4, tilboshot5,
    tilboshot6, tilboshot7, tilboshot8, tilboshot9, tilboshot10,
    tilboshot11, tilboshot12, tilboshot13, tilboshot14, tilboshot15,
    tilboshot16, tilboshot17, tilboshot18
  ];

  // חלוקה לשתי קרוסלות
  const topCarouselImages = carouselImages.slice(0, 9);
  const bottomCarouselImages = carouselImages.slice(9, 18);

  // תמונות אירועים לגלריה
  const galleryImages = [
    event1, event2, event3, event4, event5,
    event6, event7, event8, event9, event10,
    event11, event12, event13, event14, event15, event16, event17, event18, event19, event20
  ];

  // פונקציות לניהול overlay
  const openOverlay = (index) => {
    setCurrentImageIndex(index);
    setOverlayOpen(true);
    document.body.style.overflow = 'hidden'; // מונע גלילה של הדף
  };

  const closeOverlay = () => {
    setOverlayOpen(false);
    setDragOffset(0);
    document.body.style.overflow = 'unset';
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  // פונקציות לטיפול בהחלקה (Touch)
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
    setIsDragging(true);
  };

  const onTouchMove = (e) => {
    if (!touchStart) return;
    const currentTouch = e.targetTouches[0].clientX;
    setTouchEnd(currentTouch);
    // עדכון offset לאנימציה בזמן אמת
    const diff = currentTouch - touchStart;
    setDragOffset(diff);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setIsDragging(false);
      setDragOffset(0);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    // החלקה שמאלה = תמונה הבאה (כיוון RTL)
    if (isLeftSwipe) {
      nextImage();
    }
    // החלקה ימינה = תמונה קודמת (כיוון RTL)
    if (isRightSwipe) {
      prevImage();
    }
    
    // איפוס
    setTouchStart(null);
    setTouchEnd(null);
    setIsDragging(false);
    setDragOffset(0);
  };

  // פונקציות לטיפול בהחלקה (Mouse - לדסקטופ)
  const onMouseDown = (e) => {
    setTouchEnd(null);
    setTouchStart(e.clientX);
    setIsDragging(true);
  };

  const onMouseMove = (e) => {
    if (!isDragging || !touchStart) return;
    const currentPosition = e.clientX;
    setTouchEnd(currentPosition);
    const diff = currentPosition - touchStart;
    setDragOffset(diff);
  };

  const onMouseUp = () => {
    if (!touchStart || !touchEnd) {
      setIsDragging(false);
      setDragOffset(0);
      return;
    }
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    
    if (isLeftSwipe) {
      nextImage();
    }
    if (isRightSwipe) {
      prevImage();
    }
    
    setTouchStart(null);
    setTouchEnd(null);
    setIsDragging(false);
    setDragOffset(0);
  };

  const onMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      setDragOffset(0);
      setTouchStart(null);
      setTouchEnd(null);
    }
  };

  // טיפול בלחיצה על תמונה - מונע התפשטות האירוע
  const handleImageClick = (index, e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // טיפול מיוחד למובייל - delay קטן כדי לא להתנגש עם האנימציה
    setTimeout(() => {
      openOverlay(index);
    }, 50);
  };

  // טיפול במקשי מקלדת
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!overlayOpen) return;
      
      if (e.key === 'Escape') {
        closeOverlay();
      } else if (e.key === 'ArrowRight') {
        prevImage(); // ימינה = הקודם (כיוון RTL)
      } else if (e.key === 'ArrowLeft') {
        nextImage(); // שמאלה = הבא (כיוון RTL)
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [overlayOpen]);

  // אם התמונה עדיין לא נטענה, מציג את ה-Loader
  if (!imageLoaded) {
    return (
      <>
        <Loader />
        {/* תמונה נסתרת לטעינה */}
        <img 
          src={ilanit} 
          alt="אילנית ראשית" 
          style={{ display: 'none' }}
          onLoad={() => setImageLoaded(true)}
        />
      </>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.heroContainer}>
        {/* כותרת עליונה */}
        <div className={styles.headerSection}>
          {/* אייקוני רשתות חברתיות */}
          <div className={styles.socialContainer}>
            <div className={styles.socialGrid}>
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.socialLink}
                  aria-label={link.label}
                >
                  <div className={styles.iconWrapper}>
                    {link.icon}
                  </div>
                </a>
              ))}
            </div>
          </div>

          <p className={styles.subtitle}>
            מתכננים לעשות חינה בקרוב?
          </p>
          <h1 className={styles.title}>
            תכירו את <span className={styles.goldText}>חינת הזהב</span>
          </h1>
          <p className={styles.description}>
            הפקת חינה מרוקאית מלאה במקום אחד - עם תלבושות מהודרות, עיצוב עשיר, אנרגיה סוחפת והנחיית טקס שתשאיר את כולם על הרגליים
          </p>

          {/* מספר טלפון */}
          <a href="tel:+972507277178" className={styles.phoneLink}>
            050-727-7178
          </a>

          {/* כפתור קריאה לפעולה */}
          <button className={styles.ctaButton} onClick={openWhatsApp}>
            אילנית, בואי נדבר על האירוע שלי
          </button>
        </div>

        {/* קרוסלה עליונה - נעה שמאלה */}
        <div className={styles.carouselWrapper}>
          <div className={styles.carouselTop}>
            {[...topCarouselImages, ...topCarouselImages, ...topCarouselImages].map((img, index) => {
              const actualIndex = index % topCarouselImages.length;
              return (
                <div 
                  key={index} 
                  className={styles.carouselItem}
                  onClick={(e) => handleImageClick(actualIndex, e)}
                  onTouchEnd={(e) => handleImageClick(actualIndex, e)}
                >
                  <img src={img} alt={`תלבושת ${actualIndex + 1}`} />
                </div>
              );
            })}
          </div>
        </div>

        {/* תמונה ראשית במרכז */}
        <div className={styles.mainImageContainer}>
          <img src={ilanit} alt="אילנית ראשית" className={styles.mainImage} />
        </div>

        {/* קרוסלה תחתונה - נעה ימינה */}
        <div className={styles.carouselWrapper}>
          <div className={styles.carouselBottom}>
            {[...bottomCarouselImages, ...bottomCarouselImages, ...bottomCarouselImages].map((img, index) => {
              const actualIndex = 9 + (index % bottomCarouselImages.length);
              return (
                <div 
                  key={index} 
                  className={styles.carouselItem}
                  onClick={(e) => handleImageClick(actualIndex, e)}
                  onTouchEnd={(e) => handleImageClick(actualIndex, e)}
                >
                  <img src={img} alt={`תלבושת ${actualIndex + 1}`} />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ========== סקשן גלריית תמונות האירועים ========== */}
      <div className={styles.gallerySection}>
        <h2 className={styles.galleryTitle}>
          לפני הכל.. <span className={styles.goldText}>טעימה מהאירועים שלנו</span>
        </h2>
        <Shorts/>

        {/* כפתור קריאה לפעולה מתחת לגלריה */}
        <div className={styles.galleryCtaWrapper}>
          <button className={styles.ctaButton} onClick={openWhatsApp}>
            אילנית, בואי נדבר על האירוע שלי
          </button>
        </div>
      </div>

      {/* ========== Overlay לתצוגת תמונה במסך מלא עם תמיכה בהחלקה ========== */}
      {overlayOpen && (
        <div className={styles.overlay} onClick={closeOverlay}>
          {/* כפתור סגירה */}
          <button className={styles.closeButton} onClick={closeOverlay}>
            ✕
          </button>

          {/* חץ ימין (הקודם) */}
          <button 
            className={`${styles.navButton} ${styles.navButtonRight}`}
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            ←
          </button>

          {/* התמונה עם תמיכה בהחלקה */}
          <div 
            className={styles.overlayImageContainer} 
            onClick={(e) => e.stopPropagation()}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseLeave}
            style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
          >
            <div 
              className={styles.swipeContainer}
              style={{
                transform: `translateX(${dragOffset}px)`,
                transition: isDragging ? 'none' : 'transform 0.3s ease-out'
              }}
            >
              <img 
                src={carouselImages[currentImageIndex]} 
                alt={`תלבושת ${currentImageIndex + 1}`}
                className={styles.overlayImage}
                draggable={false}
              />
            </div>
            <div className={styles.imageCounter}>
              {currentImageIndex + 1} / {carouselImages.length}
            </div>
            {/* אינדיקטור החלקה */}
            <div className={styles.swipeIndicator}>
              <span>← החליקי לצדדים →</span>
            </div>
          </div>

          {/* חץ שמאל (הבא) */}
          <button 
            className={`${styles.navButton} ${styles.navButtonLeft}`}
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            →
          </button>
        </div>
      )}
    </div>
  );
};

export default HeroSection;